import type React from "react";
import FilterIcon from "../SVGComponents/FilterIcon";
import styles from "./Filter.module.scss";
import Popover from "@mui/material/Popover";
import { useMemo } from "react";
import { getInitialValues } from "@/lib/utils";
import formRenderer from "@/lib/formRenderer";
import { useForm } from "react-hook-form";
import { Button, Divider } from "@mui/material";

interface FilterProps {
  anchorEl: HTMLElement | null;
  onClick: (event: React.MouseEvent<HTMLElement>) => void;
  onClose: () => void;
  onApply: (filters: { status?: string }) => void; 
}

const Filter: React.FC<FilterProps> = ({
  anchorEl,
  onClick,
  onClose,
  onApply,
}) => {
  const open = Boolean(anchorEl);

  const statusList = [
    { label: "Approved", value: "Approved" },
    { label: "Pending", value: "Pending" },
    { label: "Rejected", value: "Reject" },
  ];

  const formConfig = useMemo(
    () => ({
      status: {
        defaultValue: null,     
        controlType: "select",
        placeholder: "Status",
        label: "By Status",
        options: statusList,
        isControlled: true,
        isMulti: false,     
      },
    }),
    []
  );

  const { register, control, formState, watch, reset,getValues } = useForm({
    defaultValues: getInitialValues(formConfig),
    mode: "onTouched",
  });

  const handleApply = () => {
    const values = getValues();
    
    onApply({
      status: values.status || "", 
    });

    onClose();
  };

  const handleClear = () => {
    reset();
    onApply({});
    onClose();
  };

  return (
    <>
      <span className={styles.filter} onClick={onClick}>
        <FilterIcon />
      </span>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <form className="p-5">
          <div className="grid grid-cols-1 gap-1.5 p-4">
            {formRenderer(formConfig, formState, register, control)}
          </div>

          <Divider />

          <div className="flex justify-end gap-4 p-3">
            <Button
              variant="contained"
              onClick={handleClear}
              style={{ backgroundColor: "white", color: "black" }}
            >
              Clear
            </Button>

            <Button variant="contained" onClick={handleApply}>
              Apply
            </Button>
          </div>
        </form>
      </Popover>
    </>
  );
};

export default Filter;
